import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Util} from "../../app/util";
import {CONFIG} from "../../app/config";
import {ENUM, TCertifyFlag, TImageModel, TImageSpace} from "../../app/enum";

@Component({
    selector: 'image-scroll',
    templateUrl: 'image-scroll.html'
})

export class ImageScroll {

    TImageModel: any = TImageModel;
    TImageSpace: any = TImageSpace;

    public config: any;

    public arrayList: any[] = [];
    public iscrollSomar: number = 0;

    @Input('iscroll-model') public iscrollModel: TImageModel;
    @Input('iscroll-array') public iscrollArray: any[];
    @Input('iscroll-molde') public iscrollMolde: string;
    @Input('iscroll-rolar') public iscrollRolar: 'x' | 'y' = 'x';
    @Input('iscroll-align') public iscrollAlign: 'left' | 'center' = 'center';
    @Input('iscroll-width') public iscrollWidth: any = '100%';
    @Input('iscroll-midth') public iscrollMidth: any = 95;
    @Input('iscroll-count') public iscrollCount: number = 0;
    @Input('iscroll-vazao') public iscrollVazao: number = 2;
    @Input('iscroll-addup') public iscrollAddup: boolean = false;
    @Input('iscroll-index') public iscrollIndex: any[] = [];
    @Input('iscroll-space') public iscrollSpace: TImageSpace = TImageSpace.is05px;

    @Output('itemAddup') private _addup: EventEmitter<any> = new EventEmitter();
    @Output('itemIndex') private _index: EventEmitter<any> = new EventEmitter();
    @Output('itemClick') private _click: EventEmitter<any> = new EventEmitter();
    @Output('itemPress') private _press: EventEmitter<any> = new EventEmitter();
    @Output('itemModel') private _model: EventEmitter<any> = new EventEmitter();

    constructor(private util: Util) {

        this.config = CONFIG;

    }

    ngOnInit() {

        if (!this.iscrollArray || !this.iscrollArray[0]) {
            //this.util.alertSimply('iscrollArray Undefined!', 'Developer Error');
            return;
        }


        if (this.iscrollModel == TImageModel.imPackage) {

            let array = [];
            this.iscrollArray.forEach(BL => {
                BL.Packages.forEach(PK => {
                    if (PK.Produtos.length) {
                        let prepare = this.util.deepCopy(BL);
                        prepare.Package = this.util.deepCopy(PK);
                        delete prepare.Packages;
                        array.push(prepare);
                    }
                });
            });

            this.iscrollArray = array;

        }




        let insert: any;
        let value = this.iscrollModel;
        this.arrayList = [];
        this.iscrollSomar = (this.iscrollCount * this.iscrollVazao);
        this.iscrollArray.forEach((item, index) => {

            //TImageModel.imMethodo
            let randomcur = Math.random() > 0.5 ? (Math.random() > 0.5 ? 'CorRoxa' : 'CorVerm') : 'CorInox';
            let randomcor = this.config.negative(randomcur);

            //TImageModel.imColor
            let corhex = this.config.colors[item.value];
            let cortxt = (item.value || '').substr(3, 4);
            let corrgb = this.config.hexToRgb(corhex);
            let corstr = corrgb.r + ' | ' + corrgb.g + ' | ' + corrgb.b;
            let corneg = this.config.negative(item.value);
            //let corbgc = this.iscrollIndex.indexOf(item.value) >= 0 ? item.value : 'CorMilk';
            let corbgc = item.value;

            if (value == TImageModel.imPendent) corbgc = (this.util.strToDate(item.ParcelaData) > this.util.dateHoje() ? 'CorLime' : 'CorFood');

            //TImageModel.imHotspot
            let brandx = (item.Branded ? item.Branded : item);

            //TImageModel.imCertrue
            let moxin = null;
            if (value == TImageModel.imCertrue) moxin = item.ProdutoSeals.find(bx => (bx.Certify && bx.Certify.CertifyFlag == TCertifyFlag.cfAprovado));


            //TImageModel.imPatente || TImageModel.imProfile || TImageModel.imStories
            let show = this.util.nomeFirst(item.ProfileShow);

            insert = null;

            let badge = null;
            if (value == TImageModel.imCluster) {
                badge = this.util.jsCount(item.Value, ['Value']);
            }


            if (value == TImageModel.imMedalha && !!item.Level)   insert = {
                imagem: {cor: null, src: item.Value[item.Level-1].MedalhaLink},
                barrow: null,
                radius: false,
                border: null,
                header: null,
                center: {cor: null,    txt: null, bgc: null},
                footer: null,
                rodape: null,
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imMethodo)   insert = {
                imagem: {cor: 'CorMenu', src: item.MethodoBase},
                barrow: null,
                radius: false,
                border: null,//'CorText',//'CorHold' //'CorMilk'
                header: {cor: randomcor, txt: item.MethodoNome, bgc: randomcur},
                center: null,
                footer: {cor: 'CorDash', txt: '', bgc: null}, //this.util.dataft(item.PaymentPago), bgc: null},
                rodape: {cor: 'CorLime', txt: '', bgc: null}, //this.util.dinheiro(item.PaymentCash), bgc: null},
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imColor)   insert = {
                imagem: null,
                barrow: null,
                radius: false,
                border: 'CorText',
                header: null,
                center: {cor: corneg,    txt: cortxt, bgc: item.value},
                footer: {cor: 'CorHold', txt: item.value, bgc: corbgc},
                rodape: {cor: 'CorHold', txt: corstr, bgc: corbgc},
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imCluster)   insert = {
                imagem: {cor: item.ClusterTint, src: item.ClusterIcon},
                barrow: null,
                radius: false,
                border: (item.ClusterTint || 'CorGelo'),
                header: null,
                center: null,
                footer: {cor: 'CorMenu', txt: item.ClusterNome, bgc: 'CorMilk'},
                rodape: null,
                badger: (!badge ? null : {cor: 'CorPele', txt: badge,   bgc: 'CorTube'}),
                alarme: null,
            };

            if (value == TImageModel.imBranded)   insert = {
                imagem: {cor: null, src: brandx.BrandedLogo},
                barrow: null,
                radius: false,
                border: brandx.BrandedCora,
                header: {cor: this.config.negative(brandx.BrandedCora), txt: brandx._negocio.NegocioNome, bgc: brandx.BrandedCora},
                center: null,
                footer: {cor: this.config.negative(brandx.BrandedCora), txt: brandx.BrandedNome, bgc: brandx.BrandedCora},
                rodape: null,
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imBlended)   insert = {
                imagem: {cor: null, src: item.BlendedFoto},
                barrow: null,
                radius: false,
                border: 'CorHold',
                header: null,
                center: null,
                footer: {cor: 'CorMenu', txt: item.BlendedNome, bgc: 'CorMilk', cls: 'font-bold font-size-12'},
                rodape: {cor: 'CorMenu', txt: item.Branded.BrandedNome, bgc: 'CorMilk', cls: null},
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imPackage)   insert = {
                imagem: {cor: null, src: item.Package.Produtos[0].ProdutoFoto},
                barrow: null,
                radius: false,
                border: 'CorHold',
                header: {cor: 'CorText', txt: (item.Package.PackageNome || '&nbsp;'), bgc: 'CorIced'},
                center: null,
                footer: {cor: 'CorMenu', txt: item.BlendedNome, bgc: 'CorMilk', cls: 'font-bold font-size-12'},
                rodape: {cor: 'CorMenu', txt: item.Branded.BrandedNome, bgc: 'CorMilk', cls: null},
                badger: null,
                alarme: (index < this.iscrollArray.length-1 ? null : {cor: 'CorMilk', txt: 'ESGOTADO', bgc: 'CorVerm'}),
            };

            if (value == TImageModel.imMeritum)   insert = {
                imagem: {cor: null, src: item.Branded.BrandedSymb},
                barrow: item.BrandedCora,
                radius: false,
                border: null,//'CorText',
                header: null,//{cor: 'CorInox', txt: item.Branded.BrandedNome,  bgc: 'CorMenu'},
                center: null,
                footer: {cor: 'CorText', txt: item.Branded.BrandedNome,  bgc: null},//null,
                rodape: null,//{cor: 'CorMenu', txt: item.MeritumNome,  bgc: null, cls: 'font-bold font-size-12'},//{cor: 'CorInox', txt: item.MeritumNome,  bgc: 'CorMenu'},
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imBlstyle)   insert = {
                imagem: {cor: null, src: item.BlendedFoto},
                barrow: null,
                radius: false,
                border: 'CorHold',
                header: null,
                center: null,
                footer: {cor: 'CorMenu', txt: item.BlendedNome, bgc: 'CorMilk', cls: 'font-bold font-size-12'},
                rodape: null, //{cor: 'CorMenu', txt: item.Branded.BrandedNome, bgc: 'CorMilk', cls: null},
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imCertify) insert = {
                imagem: {cor: null, src: item.ProdutoFoto},
                barrow: null,
                radius: false,
                border: 'CorText',
                header: null,
                center: null,
                footer: {cor: 'CorHold', txt: item.ProdutoNome, bgc: 'CorMilk'},
                rodape: null,
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imCertrue) insert = {
                imagem: {cor: null, src: moxin.ProdutoFoto},
                barrow: null,
                radius: false,
                border: null,
                header: null,
                center: null,
                footer: {cor: 'CorText', txt: item.BlendedNome, bgc: null},
                rodape: {cor: 'CorMenu', txt: moxin.ProdutoNome, bgc: null, cls: 'font-bold font-size-12'},
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imPatente)   insert = {
                imagem: {cor: null, src: item.Profile.ProfileFace},
                barrow: null,
                radius: true,
                border: null,
                header: null,
                center: null,
                footer: {cor: 'CorHold', txt: show, bgc: 'CorMilk'},
                rodape: {cor: ENUM.certifyFlag(item.CertifyFlag, 'text'), txt: TCertifyFlag[item.CertifyFlag].slice(2, 99), bgc: null},
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imGatewey)   insert = {
                imagem: {cor: null, src: item.GateweyLogo},
                barrow: null,
                radius: false,
                border: null,
                header: null,
                center: null,
                footer: null,
                rodape: null,
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imHotspot)   insert = {
                imagem: {cor: brandx.BrandedCora, src: brandx.BrandedBase},
                barrow: brandx.BrandedCora,
                radius: false,
                border: brandx.BrandedCora,
                header: null,
                center: null,
                footer: {cor: 'CorHold', txt: brandx.BrandedCity, bgc: 'CorMilk'},
                rodape: null,
                badger: null,
                alarme: null,
            };

            //#NOUSE
            //<image-scroll [iscroll-model]="TImageModel.imStories" [iscroll-array]="akkjson.checkin.Friendys" [iscroll-rolar]="'x'" [iscroll-align]="'left'" [iscroll-width]="60" [iscroll-midth]="60" [iscroll-space]="TImageSpace.is10px" (itemClick)="XXX($event)" (itemModel)="YYY()"></image-scroll-->
            //@ViewChild('imageScrall') scrollHotstories: ElementRef;
            //if (this.scrollHotstories) setTimeout(() => this.scrollHotstories.nativeElement.scrollLeft = (5 * 70));

            if (value == TImageModel.imProfile || value == TImageModel.imStories)   {

                let cor = this.iscrollMolde ? 'CorDark' : 'CorText';
                let bgc = this.iscrollMolde ? 'CorWeek' : '';

                // todo: the history ajuste fix 1349
                /*
                if (0 == 0) {
                    let coresBg = ['CorWeek', 'CorTube', 'CorRosa', 'CorBlue', 'CorLime', 'CorLime', 'CorFire', 'CorRoxa'];
                    bgc = coresBg[Math.floor(Math.random() * coresBg.length)];
                    cor = CONFIG.negative(bgc);
                } */

                insert = {
                    imagem: {cor: null, src: item.ProfileFace},
                    barrow: null,
                    radius: true,
                    border: null,
                    header: null,
                    center: null,
                    footer: ((value == TImageModel.imStories && !this.iscrollMolde) ? null : {cor: cor, txt: show, bgc: bgc}),
                    rodape: null,
                    badger: null,
                    alarme: null,
                };

            }

            if (value == TImageModel.imUsuario)   {

                let ringCor = !this.iscrollMolde ? null : 'CorWeek';

                let cor = 'CorDark';
                let bgc = 'CorWeek';

                // todo: the history ajuste fix 1349
                if (0 == 0) {
                    ringCor = 'CorRoxa';
                    bgc = 'CorGold';
                    cor = CONFIG.negative(bgc);
                }

                insert = {
                    imagem: {cor: null, src: item.Profile.ProfileFace},
                    barrow: null,
                    radius: true,
                    border: null,
                    ring: {size: 5, cor: ringCor},
                    header: null,
                    center: null,
                    footer: !this.iscrollMolde ? null : {cor: cor, txt: item.Profile.ProfileShow, bgc: bgc},
                    rodape: null,
                    badger: null,
                    alarme: null,
                };

            }

            //#NOUSE
            //<image-scroll [iscroll-model]="TImageModel.imCheckin" [iscroll-array]="rootile.Paybooks" [iscroll-align]="'center'" [iscroll-width]="100" [iscroll-midth]="100" (itemClick)="paybookMenu($event)"></image-scroll>
            if (value == TImageModel.imCheckin)   insert = {
                imagem: {cor: item.Branded.BrandedCora, src: item.Branded.BrandedBase}, //'CorDash'
                barrow: null,
                radius: false,
                border: 'CorText',
                header: null,
                center: null,
                footer: {cor: 'CorHold', txt: this.util.dataft(item.PaybookCria), bgc: 'CorGelo'},
                rodape: null,
                badger: null,
                alarme: null,
            };

            if (value == TImageModel.imPendent)   insert = {
                imagem: 'b-icon-dollar',
                barrow: corbgc,
                radius: false,
                border: corbgc,
                header: {cor: (corbgc == 'CorLime' ? 'CorText' : 'CorMilk'), txt: (corbgc == 'CorLime' ? 'vencer' : 'vencido'), bgc: corbgc},
                center: {cor: (corbgc == 'CorLime' ? 'CorMato' : corbgc),    txt: this.util.dinheiro(item.ParcelaCash, false), bgc: item.value},
                footer: {cor: (corbgc == 'CorLime' ? 'CorText' : 'CorMilk'), txt: this.util.dataft(item.ParcelaData, 'dd', 'char', null, ' '), bgc: corbgc},
                rodape: null,
                badger: null,
                alarme: null,
            };


            if (insert) this.arrayList.push(insert);

        });

    }

    update() {

        this.ngOnInit();

    }

    moldeStyle() {

        let moldeStyle = {};

        if (this.iscrollMolde) {
            moldeStyle = {
                padding: this.iscrollMolde ? (this.iscrollWidth == 120 ? '20px' : '30px') : '',
                display: 'flex',
                'justify-content': 'center',
                'align-items': 'center',
                background: 'url(' + this.iscrollMolde + ') no-repeat scroll center center / cover'
            };
        }

        return moldeStyle;

    }

    bsMolder(value: 'scale' | 'width'): any {

        if (this.iscrollModel == TImageModel.imMedalha) return (value == 'scale' ? '1x1' : '100%');
        if (this.iscrollModel == TImageModel.imMethodo) return (value == 'scale' ? '1x1' : '100%');
        if (this.iscrollModel == TImageModel.imColor)   return (value == 'scale' ? '1x1' : '100%');
        if (this.iscrollModel == TImageModel.imCluster) return (value == 'scale' ? '1x1' : 200);
        if (this.iscrollModel == TImageModel.imBranded) return (value == 'scale' ? '1x1' : 200);
        if (this.iscrollModel == TImageModel.imBlended) return (value == 'scale' ? '1x1' : 200);
        if (this.iscrollModel == TImageModel.imPackage) return (value == 'scale' ? '2x3' : 200);
        if (this.iscrollModel == TImageModel.imMeritum) return (value == 'scale' ? '1x1' : 200);
        if (this.iscrollModel == TImageModel.imBlstyle) return (value == 'scale' ? '1x1' : 200);
        if (this.iscrollModel == TImageModel.imCertify) return (value == 'scale' ? '2x3' : 200);
        if (this.iscrollModel == TImageModel.imCertrue) return (value == 'scale' ? '2x3' : 120);
        if (this.iscrollModel == TImageModel.imPatente) return (value == 'scale' ? '1x1' : 80);
        if (this.iscrollModel == TImageModel.imGatewey) return (value == 'scale' ? '3x1' : 400);
        if (this.iscrollModel == TImageModel.imHotspot) return (value == 'scale' ? '1x1' : 100);
        if (this.iscrollModel == TImageModel.imProfile) return (value == 'scale' ? '1x1' : '100%');
        if (this.iscrollModel == TImageModel.imStories) return (value == 'scale' ? '1x1' : '100%');
        if (this.iscrollModel == TImageModel.imUsuario) return (value == 'scale' ? '1x1' : '100%');
        if (this.iscrollModel == TImageModel.imCheckin) return (value == 'scale' ? '1x1' : '100%'); //#NOUSE
        if (this.iscrollModel == TImageModel.imPendent) return (value == 'scale' ? '1x1' : '100%');
        return '';

    }

    bsMore(press: boolean) {

        let pressNao = this.iscrollSomar;
        let pressYes = this.arrayList.length;

        this.iscrollCount += (!press ? pressNao : pressYes);
        if (press) this.util.impact();

    }

    bsAchata(): boolean {

        return (this.iscrollModel == TImageModel.imMethodo);

    }

    bsClass(add?): any {

        let sx = (this.iscrollRolar == 'x');
        let sy = (this.iscrollRolar == 'y');

        if (this.iscrollSpace == TImageSpace.isSobre) return {'margin-x-5-n': sx, 'margin-y-5': (sx || sy), [add]: !!add};
        if (this.iscrollSpace == TImageSpace.is05px)  return {'margin-x-5':  (sx || sy), 'margin-y-5':  sy, [add]: !!add};
        if (this.iscrollSpace == TImageSpace.is10px)  return {'margin-x-10': (sx || sy), 'margin-y-10': sy, [add]: !!add};
        if (this.iscrollSpace == TImageSpace.is20px)  return {'margin-x-20': (sx || sy), 'margin-y-10': sy, [add]: !!add};

        return null;
    }

    bsStyle(): any {

        //let sx = (this.iscrollRolar == 'x');
        //let sy = (this.iscrollRolar == 'y');

        //isSobre =>
        //if (this.iscrollSpace == TImageSpace.isSobre) return {'margin-left': ((this.iscrollWidth / 6) * -1) + 'px'};

        return null;

    }

    _emitModel(model) {

        this._model.emit(model);

    }

    _emitClick(index) {

        this._index.emit(index);
        this._click.emit(this.iscrollArray[index]);

    }

    _emitPress(index) {

        this._press.emit(this.iscrollArray[index]);

    }

    _emitAddup() {

        this._addup.emit(null);

    }

}



// WEBPACK FOOTER //
// ./src/components/image-scroll/image-scroll.ts